const state = {
  relatedOffersCartDialog: false,
  relatedOffers: [],
  pendingCreditOfferedId: null,
  redirectTo: null,
};

const getters = {
  getRelatedOffersCartDialog: () => state.relatedOffersCartDialog,
  getRelatedOffersForCart: () => state.relatedOffers,
  getPendingCreditOfferedId: () => state.pendingCreditOfferedId,
  getRelatedOffersRedirectTo: () => state.redirectTo,
};

const actions = {
  openRelatedOffersCartDialog({ commit }, payload) {
    commit('setRelatedOffers', payload.relatedOffers || []);
    commit('setPendingCreditOfferedId', payload.pendingCreditOfferedId || null);
    commit('setRelatedOffersRedirectTo', payload.redirectTo || null);
    commit('setRelatedOffersCartDialog', true);
  },

  closeRelatedOffersCartDialog({ commit }) {
    commit('setRelatedOffersCartDialog', false);
    commit('setRelatedOffers', []);
    commit('setPendingCreditOfferedId', null);
    commit('setRelatedOffersRedirectTo', null);
  },
};

const mutations = {
  setRelatedOffersCartDialog($state, payload) {
    const stateCopy = $state;
    stateCopy.relatedOffersCartDialog = payload;
  },

  setRelatedOffers($state, payload) {
    const stateCopy = $state;
    stateCopy.relatedOffers = payload;
  },

  setPendingCreditOfferedId($state, payload) {
    const stateCopy = $state;
    stateCopy.pendingCreditOfferedId = payload;
  },

  setRelatedOffersRedirectTo($state, payload) {
    const stateCopy = $state;
    stateCopy.redirectTo = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
